import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Carousel,
  Col,
  Container,
  Form,
  InputGroup,
  Overlay,
  Row,
  Table,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios, { Axios } from "axios";
import actionLog from "../../assets/images/actionLog.svg";
import activestatus from "../../assets/images/activeStatus.svg";
import addicon from "../../assets/images/addicon.svg";

import notification from "../../assets/images/notification.svg";
import DemoLogo from "../../assets/images/quantummain.svg";
import calendar from "../../assets/images/calendar.svg";
import cardicon from "../../assets/images/cardicon.svg";
import crossarrow from "../../assets/images/crossarrow.svg";
import deleteAction from "../../assets/images/deleteaction.svg";
import editAction from "../../assets/images/editaction.svg";
import historyAction from "../../assets/images/historyaction.svg";
import inactivestatus from "../../assets/images/inactivestatus.svg";
import listicon from "../../assets/images/list.svg";
import greenTick from "../../assets/images/greenTick.svg";
import redCross from "../../assets/images/redCross.svg";
import playblackicon from "../../assets/images/playblackicon.svg";
import payment_cancel from "../../assets/images/payment_cancel.svg";
import payment_inprocess from "../../assets/images/payment_inprocess.svg";
import payment_success from "../../assets/images/payment_success.svg";
import payment_wait from "../../assets/images/payment_wait.svg";

import arrowleft from "../../assets/images/reshot-icon-arrow-left.svg";
import viewAction from "../../assets/images/viewaction.svg";
import AddProjectPopup from "../common-component/AddProjectPopup";
import SingleProjectCard from "../common-component/SingleProjectCard";
import StackedBarChart from "../common-component/StackedBarChart";
import DailyActivityChart from "../common-component/StackedBarChartWithLine";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from "../../Modals/DeleteModal";
import { API_URL } from "../../services/APIRoute";
import {
  commonservices,
  CurrentYear,
  TIMEZONE_LIST,
  MonthsArrayList,
} from "../../services/CommonServices";
import {
  GetDashBoardWorkFlowList,
  GetWorkflowStatistics,
  GetDashboardTodayWorkflowStatisticsCount,
} from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import LineChartWithPointInline from "../common-component/LineChartWithPointInline";
import Loader, { LoaderType } from "../common-component/Loader";
import Nodata from "../common-component/Nodata";
import NotificationPopup from "../common-component/NotificationPopup";
import SchedularPopup from "../common-component/SchedularPopup";
import Walkthrough from "../common-component/Walkthrough";
import WorkFlowLogModal from "../common-component/WorkFlowLogModal";
import {
  getCostwidgetdata,
  getDataCloudHealthCount,
  getMonthlycostbydataby,
  getDashboardDailyActivityData,
} from "../../services/ReduxTookit/Slice/ReportRedux";
import { MachinePurchaseList } from "../../services/ReduxTookit/Slice/MachineRedux";
import { apiCall } from "../../services/AxiosService";
import { BlogGetList } from "../../services/ReduxTookit/Slice/WordpressApi";
import { BlogGetListNews } from "../../services/ReduxTookit/Slice/BlogRedux";
import Skeleton from "react-loading-skeleton";
import profilepic1 from "../../assets/images/dummy-profile-pic.jpg";
import searchicon from "../../assets/images/searchicon.svg";
import useDebounce from "../../hooks/useDebounce";
import {
  AutoPayment,
  CreatePayment,
  PaymentMethodList,
  PaymentStatusCheck,
  PaymentMethod_PaymentStatusCheck,
} from "../../services/ReduxTookit/Slice/InvoiceRedux";
import { toast } from "react-toastify";
import PaymentMethodSelection from "../../Modals/PaymentMethodSelection";
import { Doughnut } from "react-chartjs-2";
import MachineWiseCostPopup from "../common-component/MachineWiseCostPopup";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Legend);

// External HTML tooltip handler to enable scrolling for large tooltips
const externalTooltipHandler = (context) => {
  const { chart, tooltip } = context;
  let tooltipEl = document.getElementById('chartjs-scrollable-tooltip');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartjs-scrollable-tooltip';
    // Inline critical styles to avoid CSS conflicts
    Object.assign(tooltipEl.style, {
      position: 'fixed',
      background: 'rgba(0, 0, 0, 0.88)',
      color: '#fff',
      borderRadius: '6px',
      padding: '10px 12px',
      fontSize: '12px',
      lineHeight: '1.4',
      maxHeight: '260px',
      maxWidth: '340px',
      overflowY: 'auto',
      overflowX: 'hidden',
      pointerEvents: 'auto',
      zIndex: '99999',
      transition: 'opacity 0.12s ease',
      boxShadow: '0 4px 14px rgba(0,0,0,0.3)',
      opacity: '0',
    });
    // Force scrollbar visibility (override global hidden scrollbars)
    tooltipEl.style.setProperty('scrollbar-width', 'thin', 'important');
    document.body.appendChild(tooltipEl);

    // Keep tooltip visible while hovered (so user can scroll inside it)
    tooltipEl.addEventListener('mouseenter', () => {
      tooltipEl._hovered = true;
      tooltipEl.style.opacity = '1';
      tooltipEl.style.pointerEvents = 'auto';
    });
    tooltipEl.addEventListener('mouseleave', () => {
      tooltipEl._hovered = false;
      tooltipEl.style.opacity = '0';
      tooltipEl.style.pointerEvents = 'none';
    });

    // Inject scrollbar styles once
    if (!document.getElementById('chartjs-scrollable-tooltip-style')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'chartjs-scrollable-tooltip-style';
      styleEl.innerHTML = `
        #chartjs-scrollable-tooltip::-webkit-scrollbar { width: 8px !important; display: block !important; }
        #chartjs-scrollable-tooltip::-webkit-scrollbar-track { background: rgba(255,255,255,0.08) !important; border-radius: 4px !important; display: block !important; }
        #chartjs-scrollable-tooltip::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.45) !important; border-radius: 4px !important; display: block !important; }
        #chartjs-scrollable-tooltip::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.7) !important; }
      `;
      document.head.appendChild(styleEl);
    }
  }

  if (tooltip.opacity === 0) {
    if (tooltipEl._hovered) return; // don't hide while user is interacting with it
    tooltipEl.style.opacity = '0';
    tooltipEl.style.pointerEvents = 'none';
    return;
  }

  const titleLines = tooltip.title || [];
  const bodyLines = tooltip.body.map((b) => b.lines);
  const footerLines = tooltip.footer || [];

  let innerHtml = '';
  if (titleLines.length) {
    innerHtml += `<div style="font-weight:bold;margin-bottom:6px;font-size:13px;">${titleLines.join('<br/>')}</div>`;
  }
  const rows = bodyLines
    .map((body, i) => {
      // Skip empty rows (where label callback returned null/empty)
      const text = Array.isArray(body)
        ? body.filter((l) => l && l.trim() !== "").join(" ")
        : (body || "").toString().trim();
      if (!text) return null;

      // Example label format: "workflow-name: $1.2345"
      const valueMatch = text.match(/:\s*\$?(-?[0-9,]+(?:\.[0-9]+)?)/);
      const numericValue = valueMatch
        ? Number(valueMatch[1].replace(/,/g, ""))
        : Number.NEGATIVE_INFINITY;

      return {
        text,
        colors: tooltip.labelColors[i] || {},
        numericValue,
      };
    })
    .filter(Boolean)
    .sort((a, b) => b.numericValue - a.numericValue);

  rows.forEach((row) => {
    const swatch = `<span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:${row.colors.backgroundColor};border:1px solid ${row.colors.borderColor || "rgba(255,255,255,0.3)"};margin-right:8px;flex-shrink:0;"></span>`;
    innerHtml += `<div style="display:flex;align-items:center;padding:2px 0;white-space:nowrap;">${swatch}<span>${row.text}</span></div>`;
  });
  if (footerLines.length) {
    innerHtml += `<div style="border-top:1px solid rgba(255,255,255,0.25);margin-top:6px;padding-top:6px;font-weight:bold;">${footerLines.join('<br/>')}</div>`;
  }
  tooltipEl.innerHTML = innerHtml;

  const canvasRect = chart.canvas.getBoundingClientRect();
  // Measure tooltip after content set
  const tooltipWidth = tooltipEl.offsetWidth;
  const tooltipHeight = tooltipEl.offsetHeight;

  let left = canvasRect.left + tooltip.caretX + 14;
  let top = canvasRect.top + tooltip.caretY - tooltipHeight / 2;

  // Flip to left if overflows viewport right
  if (left + tooltipWidth > window.innerWidth - 8) {
    left = canvasRect.left + tooltip.caretX - tooltipWidth - 14;
  }
  if (left < 8) left = 8;
  if (top < 8) top = 8;
  if (top + tooltipHeight > window.innerHeight - 8) {
    top = window.innerHeight - tooltipHeight - 8;
  }

  tooltipEl.style.left = left + 'px';
  tooltipEl.style.top = top + 'px';
  tooltipEl.style.opacity = '1';
  tooltipEl.style.pointerEvents = 'auto';

};

function Dashboard() {
  const toUtcYearStartIso = (year) =>
    new Date(Date.UTC(Number(year), 0, 1, 0, 0, 0, 0)).toISOString();

  const walkthroughDetail = commonservices.getWalkthroughDetail();
  const steps = [
    {
      target: ".tourWorkFlowDashboardTab",
      title: "List & Card View",
      content: "Switch Between List and Card View",
      disableBeacon: true,
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      className: "listviewstep1",
    },
    {
      target: ".tourWorkFlowDashboardAdd",
      title: "Add Workflow",
      content:
        "Start creating a new workflow by clicking Add. Enter key details like Industry, Workflow Name, and Description. Click Submit to complete setup, design workflow, configure machines and view the workflow’s progress!",
      placement: "left",
      customProp: {
        classname: "position-left",
      },
      className: "listviewstep2",
    },
    {
      target: ".tourWorkFlowDashboardName",
      title: "Workflow Name",
      content:
        "Click the workflow name to access the Workflow Engineering Screen and make detailed adjustments.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      className: "listviewstep3",
    },
    {
      target: ".tourWorkFlowDashboardStatus",
      title: "Status Indicator",
      content:
        "View the current status of this workflow, such as Active, Paused, or Error.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      className: "listviewstep4",
    },
    {
      target: ".tourWorkFlowDashboardSchedular",
      title: "Scheduler",
      content:
        "See or adjust the schedule for your workflow, setting specific run times as needed.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      height: "24px",
      width: "24px",
      className: "",
    },
    {
      target: ".tourWorkFlowDashboardNotification",
      title: "Notification",
      content:
        "Configure notifications to stay updated on this workflow’s activity and status changes.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      height: "24px",
      width: "24px",
      className: "",
    },
    {
      target: ".tourWorkFlowDashboardLog",
      title: "Logs",
      content:
        "Access logs to view the detailed history of actions and events for this workflow.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      height: "24px",
      width: "24px",
      className: "",
    },
    {
      target: ".tourWorkFlowDashboardView",
      title: "View Workflow",
      content:
        "Preview this workflow’s settings and current status without making changes.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      height: "24px",
      width: "24px",
      className: "",
    },
    {
      target: ".tourWorkFlowDashboardEdit",
      title: "Edit Workflow",
      content: "Click to edit workflow details, settings, and configuration.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      height: "24px",
      width: "24px",
      className: "",
    },
    {
      target: ".tourWorkFlowDashboardDelete",
      title: "Delete Workflow",
      content: "Remove this workflow if it’s no longer needed.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      height: "24px",
      width: "24px",
      className: "",
    },
    // {
    //   target: ".tourWorkFlowDashboardRunSummary",
    //   title: "Run Summary",
    //   content:
    //     "See the number of successful and failed runs along with timestamps for easy tracking.",
    //   placement: "right",
    //   customProp: {
    //     classname: "position-right",
    //   },
    // },
    {
      target: ".tourWorkFlowDashboardMachines",
      title: "Machines",
      content:
        "View the machines associated with this workflow and their statuses.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },

      className: "listviewstep11",
    },
    {
      target: ".tourWorkFlowDashboardBillingInfo",
      title: "Billing Information",
      content:
        "Review billing details related to this workflow’s usage and cost.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },

      className: "listviewstep12",
    },
    {
      target: ".tourWorkFlowDashboardLastRun",
      title: "Last Run",
      content: "Check when the workflow last ran to monitor recent activity.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },

      className: "listviewstep13",
    },
    {
      target: ".tourWorkFlowDashboardNextRun",
      title: "Next Scheduled Run",
      content:
        "See the upcoming scheduled run time, so you know when it will execute next.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },

      className: "listviewstep14",
    },
    {
      target: ".tourWorkFlowDashboardGraph",
      title: "Resource Usage Graphs",
      content:
        "Monitor system resource usage—CPU, Memory, and Network—to ensure optimal performance.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      // height: "100px",
      // width: "444px",
      // className: "",
      className: "listviewstep15",
    },
    {
      target: ".tourWorkFlowDashboardCost",
      title: "Cost",
      content:
        "Track your workflow costs with insights on the current month, last month, average monthly expenses, forecasted costs, and the percentage change from last month to optimize spending.",
      placement: "left",
      customProp: {
        classname: "position-left",
      },

      className: "listviewstep16",
    },
  ];
  const [callApi, setCallApi] = useState(
    walkthroughDetail?.workflowDashboard
      ? walkthroughDetail?.workflowDashboard
      : false,
  );
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const location = useLocation();
  const [searchValue, setSearchValue] = useState("");
  const debouncingValue = useDebounce(searchValue, 500);
  const [activeTab, setActiveTab] = useState(1);
  const [isPaying, setIsPaying] = useState(false);

  useEffect(() => {
    if (location?.state?.param === "dc") {
      setActiveTab(1);
    } else if (location?.state?.param === "dl") {
      setActiveTab(0);
    }
  }, [location]);

  const [flowName, setFlowName] = useState("");
  const [CronParseValues, setCronParseValues] = useState([]);
  const notificationPayloadRef = useRef();
  let UserRoleRight = useSelector((state) => state.userinfo?.UserRoleRight);
  let UserData = useSelector(
    (state) => state?.userredux?.GetByPrimarykeyData?.data?.data?.data,
  );
  let checkUserType = useSelector((state) => state?.userinfo?.UserInfo);

  const [DeletePayload, setDeletePayload] = useState({
    workflowid: "",
    status: "",
  });
  const [showNotification, setShowNotification] = useState(false);
  const handleshowNotification = () => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowNotification(!showNotification);
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const MyPurchaseList = useSelector(
    (state) =>
      state?.machineredux?.MachinePurchaseListData?.data?.data?.data?.dataList1,
  );

  const handleSchedularSubmit = (data) => {
    setSchedularData(data);
  };

  const [showAddProjectPopup, setShowAddProjectPopup] = useState(false);

  const handleshowAddProjectPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowAddProjectPopup(!showAddProjectPopup);
  };
  const target = useRef(null);
  const target2 = useRef(null);

  const target1 = useRef(null);
  const chartRef = useRef(null);
  const [show, setShow] = useState(false);
  const SetScheduler = (item) => {
    let schedularDataObj = {
      "WorkFlowSchedule.timezone": item?.timezone,
      "WorkFlowSchedule.startondatetime": item?.startondatetime
        ? moment(item?.startondatetime).format("YYYY-MM-DD")
        : "",
      "WorkFlowSchedule.endondatetime": item?.endondatetime
        ? moment(item?.endondatetime).format("YYYY-MM-DD")
        : "",
      "WorkFlowSchedule.scheduledays": item?.scheduledays,
      "WorkFlowSchedule.schedulemonth": item?.schedulemonth,
      "WorkFlowSchedule.hour": item?.schedulehour,
      "WorkFlowSchedule.minute": item?.scheduleminute,
      "WorkFlowSchedule.weekdays": item?.scheduleweekday,
      "WorkFlowSchedule.cronexpression": item?.cronexpression,
      "filter.minute": item?.scheduleminute === "all" ? true : false,
      "filter.hour": item?.schedulehour === "all" ? true : false,
      "filter.date": item?.scheduledays === "all" ? true : false,
    };
    setFlowName(item?.workflowname);
    setSchedularData(schedularDataObj);
  };
  const targetSchedularRef = useRef();
  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const handleOverlayForScheduler = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };
  const [showSchedulerPopup, setShowSchedulerPopup] = useState(false);

  const handleshowSchedulerPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlayForScheduler(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowSchedulerPopup(!showSchedulerPopup);
  };

  const [machinewiseflowName, setmachinewiseflowName] = useState("");
  const [machinewiseworkflowid, setmachinewiseworkflowid] = useState("");
  const [showtype, setShowType] = useState("");
  const targetMachinewiseRef = useRef({});

  const getTargetRef = (workflowid, type) => {
    const key = `${workflowid}_${type}`;
    if (!targetMachinewiseRef.current[key]) {
      targetMachinewiseRef.current[key] = React.createRef();
    }
    return targetMachinewiseRef.current[key];
  };

  const handleOverlayForMachineWiseCost = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const [showMachineWiseCostPopup, setShowMachineWiseCostPopup] =
    useState(false);

  const handleshowMachineWiseCostPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlayForMachineWiseCost(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowMachineWiseCostPopup(!showMachineWiseCostPopup);
  };

  const handleshowtypeclick = (projectname, workflowid, showtype, e) => {
    setmachinewiseflowName(projectname);
    setmachinewiseworkflowid(workflowid);
    setShowType(showtype);
    handleshowMachineWiseCostPopup(e);
  };

  useEffect(() => {
    if (UserRoleRight) {
      setRoleAccess(commonservices?.GetRoleAccess("Workflow", UserRoleRight));
    }
  }, [UserRoleRight]);

  const targetScheduler = useRef(null);
  const [modalShow, setModalShow] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  const [logId, setLogId] = useState(0);
  const [getAllMachineLoader, setGetAllMachineLoader] = useState(false);

  const dummyWorkflowList = [
    {
      workflowid: 40,
      workflowname: "Latest copied",
      workflowkey: null,
      workflowfilename: null,
      isactive: true,
      createdon: "2024-11-08T09:05:30.574594",
      createdby: 1,
      updatedon: null,
      updatedby: null,
      lastrunon: null,
      nextrunon: "2024-11-15T06:22:42.830331",
      laststatus: null,
      subscriberid: 1,
      totalcost: null,
      totalmachine: null,
      totalsuccessed: null,
      totalfailed: null,
      workflownodejson: "Latest copied_workflownodejson",
      workflowedgejson: "Latest copied_workflowedgejson",
      workflowjson: "Latest copied_workflowjson",
      workflowsavestatus: null,
      workflowscheduleid: 44,
      timezone: "Central European Standard Time",
      startondatetime: "2024-11-08T00:00:00",
      endondatetime: "2029-11-08T00:00:00",
      scheduledays: null,
      schedulemonth: null,
      repeatevery: null,
      repeatduration: null,
      cronexpression: "0 0 1 1 *",
      isrunrepeatedly: null,
      enablescheduling: null,
      enableexecution: null,
      schedulehour: null,
      scheduleminute: null,
      scheduleweekday: null,
      workflowteamid: 79,
      canview: true,
      canedit: true,
      candelete: true,
      rolename: "Subscribers",
      chartdata:
        '{"Chart Label" : "2024-11-07,2024-11-08,2024-11-09,2024-11-10,2024-11-11,2024-11-12,2024-11-13", "CPU Usage" : "0,0,0,0,0,0,0", "Memory Usage" : "0,0,0,0,0,0,0", "Network Usage" : "0,0,0,0,0,0,0"}',
    },
  ];

  const getAllMachineList = () => {
    setGetAllMachineLoader(true);
    dispatch(MachinePurchaseList())?.then((res) => {
      setGetAllMachineLoader(false);
    });
  };

  const [workflowListLast, setWorkflowListLast] = useState([]);
  const [schedularData, setSchedularData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [roleAccess, setRoleAccess] = useState({});

  const [CostwidgetdataLoader, setCostwidgetdataLoader] = useState(false);
  const [CostwidgetList, setCostwidgetList] = useState([]);

  const [ChartReportLoader, setChartReportLoader] = useState(false);

  const [BillingDrilldownData, setBillingDrilldownData] = useState([]);

  const [ChartReportData, setChartReportData] = useState({
    labels: [],
    datasets: [],
  });

  const [IsShowDrilldownChart, setIsShowDrilldownChart] = useState(false);

  const [DrilldownChartReportData, setDrilldownChartReportData] = useState({
    labels: [],
    datasets: [],
    clickedLabel: "",
  });

  const [blogList, setBlogList] = useState(null);
  const [toolBarList, setToolBarList] = useState(null);

  const [PaymentPopup, setPaymentPopup] = useState({
    show: false,
    invoiceitem: null,
    itemtype: "Workflow Invoice",
  });
  const [OnlinePaymentDetails, setOnlinePaymentDetails] = useState({
    message: "",
    paymentsessionid: "",
    paymenttransactionid: "",
    from: "",
    isshow: false,
  });

  const fnPaymentStatusCheck = async (from, sessionId) => {
    let message = "";
    let paymentsessionid = "";
    let paymenttransactionid = "";

    try {
      const rest = await dispatch(PaymentStatusCheck(sessionId));
      if (
        rest &&
        rest.payload &&
        rest.payload.isValidate &&
        rest.payload.data
      ) {
        message = rest.payload.data.message;
        paymentsessionid = rest.payload.data.data.paymentsessionid;
        paymenttransactionid = rest.payload.data.data.paymenttransactionid;
      }
    } catch (error) {}

    setOnlinePaymentDetails({
      message: message,
      paymentsessionid: paymentsessionid,
      paymenttransactionid: paymenttransactionid,
      from: from,
      isshow: true,
    });
    fngetCostwidgetdata();
  };

  const fnPaymentMethodPaymentStatusCheck = async (from, sessionId) => {
    let message = "";
    let paymentsessionid = "";
    let paymenttransactionid = "";

    try {
      const rest = await dispatch(PaymentMethod_PaymentStatusCheck(sessionId));
      if (
        rest &&
        rest.payload &&
        rest.payload.isValidate &&
        rest.payload.data
      ) {
        message = rest.payload.data.message;
        paymentsessionid = rest.payload.data.data.paymentsessionid;
        paymenttransactionid = rest.payload.data.data.paymenttransactionid;
      }
    } catch (error) {}

    setOnlinePaymentDetails({
      message: message,
      paymentsessionid: paymentsessionid,
      paymenttransactionid: paymenttransactionid,
      from: from,
      isshow: true,
    });
  };

  function refreshpagedata(from) {
    navigate("/dashboard", { replace: true });
    fngetCostwidgetdata();
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const from = queryParams.get("from");
    const sessionId = queryParams.get("session_id");

    if (from && sessionId) {
      if (from.toLowerCase() === "bill") {
        setOnlinePaymentDetails({
          message: "APICALLING",
          paymentsessionid: "",
          paymenttransactionid: "",
          from: from,
          isshow: true,
        });
        fnPaymentStatusCheck(from, sessionId);
      } else if (from.toLowerCase() === "bill_add_card") {
        setOnlinePaymentDetails({
          message: "APICALLING",
          paymentsessionid: "",
          paymenttransactionid: "",
          from: from,
          isshow: true,
        });
        fnPaymentMethodPaymentStatusCheck(from, sessionId);
      }
    }
  }, [location.search]);

  useEffect(() => {
    const storedInvoiceData = sessionStorage.getItem("reopen_bill_payment_invoice");
    if (storedInvoiceData && !OnlinePaymentDetails?.isshow) {
      try {
        const parsed = JSON.parse(storedInvoiceData);
        const invoiceItem = parsed?.item || parsed;
        const itemType = parsed?.itemtype || "Workflow Invoice";
        if (invoiceItem) {
          fngetCostwidgetdata();
          setPaymentPopup({
            show: true,
            invoiceitem: invoiceItem,
            itemtype: itemType,
          });
        }
      } catch (e) {
        console.error("Failed to parse reopen_bill_payment_invoice", e);
      } finally {
        sessionStorage.removeItem("reopen_bill_payment_invoice");
      }
    }
  }, [OnlinePaymentDetails?.isshow]);

  const [paymentReqObj, setPaymentReqObj] = useState(null);
  const [modalShowPaymentMethod, setModalShowPaymentMethod] = useState(false);
  const [paymentMethodList, setPaymentMethodList] = useState(null);
  const [dataCloudHealthCount, setDataCloudHealthCount] = useState(null);
  const [dataCloudHealthLoader, setDataCloudHealthLoader] = useState(false);
  const [ChartReportHandle, setChartReportHandle] = useState({
    year: CurrentYear,
    databy: "workflow",
  });
  const [DailyActivityChartReportHandle, setDailyActivityChartReportHandle] =
    useState({
      year: CurrentYear,
      month: new Date().getMonth() + 1,
    });

  const [workflowStatistics, setworkflowStatistics] = useState(null);
  const [workflowStatisticsCount, setWorkflowStatisticsCount] = useState(null);
  const [workflowStatisticsCountLoader, setWorkflowStatisticsCountLoader] = useState(false);
  const [DailyActivityChartReportLoader, setDailyActivityChartReportLoader] =
    useState(false);
  const [dailyActivityChartReportdata, setDailyActivityChartReportdata] =
    useState(null);
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  function getWorkFlowList() {
    setLoading(true);
    let request = {
      limit: 15,
      searchText: searchValue,
    };
    dispatch(GetDashBoardWorkFlowList(request)).then(() => {
      setLoading(false);
    });
  }

  // Update the datalist2 to datalist1 cnf by ashish
  // const WorkFlowLastDataList = useSelector(
  //   (state) =>
  //     state?.workflowredux?.GetDashBoardWorkFlowListData?.data?.data?.data
  //       ?.dataList2
  // );
  const WorkFlowLastDataList = useSelector(
    (state) =>
      state?.workflowredux?.GetDashBoardWorkFlowListData?.data?.data?.data
        ?.dataList1,
  );


  // Store chart instance for legend modal when it renders
  useEffect(() => {
    if (chartRef.current) {
      // For react-chartjs-2, the chart instance is in the ref
      window.chartInstance = { chartInstance: chartRef.current };
    }
  }, [ChartReportData, IsShowDrilldownChart]);

  const handleWalkthroughCallback = () => {
    setCallApi(true);
  };
  async function fngetCostwidgetdata() {
    setCostwidgetdataLoader(true);
    let body = {
      currentmonthdate: new Date().toISOString(),
      workflowid: null,
      timezone: browserTimezone,
    };
    dispatch(getCostwidgetdata(body))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setCostwidgetdataLoader(false);
          setCostwidgetList(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setCostwidgetList([]);
        }
      })
      .finally(() => {
        setCostwidgetdataLoader(false);
      });
  }

  const fnAutoPayment = async (item) => {
    try {
      const body = {
        amount: item.invoicefinalamount?.toFixed(2),
        paymentmethodid: paymentMethodList[0]?.paymentmethodid,
        associationid: item.invoiceid,
        associationtype: "Workflow Invoice",
      };
      const resp = await dispatch(AutoPayment(body));

      if (
        resp &&
        resp.payload &&
        resp.payload.isValidate &&
        resp.payload.data
      ) {
        if (resp.payload.data.status_code === 1) {
          // window.location = resp.payload.data.data;
          let tmpData = [...CostwidgetList];
          tmpData?.forEach((element) => (element.status_term = "Paid"));
          setCostwidgetList(tmpData);
          toast.success(resp.payload.data.message);
        }
      } else {
        toast.error("Something went wrong.");
      }
    } catch (error) { }
  };

  const fnCreatePayment = async (item) => {
    try {
      const body = {
        amount: item.invoicefinalamount?.toFixed(2),
        invoiceno: item.invoiceno,
        returnurl:
          window.location.origin +
          "/management-listing?from=bill&session_id={CHECKOUT_SESSION_ID}",
        associationid: item.invoiceid,
        associationtype: "Workflow Invoice",
      };
      const rest = await dispatch(CreatePayment(body));

      if (
        rest &&
        rest.payload &&
        rest.payload.isValidate &&
        rest.payload.data
      ) {
        if (rest.payload.data.status_code === 1 && rest.payload.data.data) {
          window.location = rest.payload.data.data;
        } else {
          toast.error(rest.payload.data.message);
        }
      }
    } catch (error) { }
  };

  async function fngetChartReport(selectedyear, databy) {
    setChartReportLoader(true);
    let body = {
      date: `${selectedyear}-01-01`,
      datagroupby: "month",
      databy: databy,
      workflowid: null,
      searchText: searchValue,
      timezone: browserTimezone,
    };
    try {
      const response = await dispatch(getMonthlycostbydataby(body));
      if (response?.payload?.isValidate) {
        let templables = [];
        let tempdatasets = [];
        let dataByLabel = {};
        const data1 = response?.payload?.data?.data || [];
        setBillingDrilldownData(data1.dataList2);
        data1.dataList1.forEach((element) => {
          templables.push(element.monthandyear);
          if (!dataByLabel[element.displayname]) {
            dataByLabel[element.displayname] = [];
          }
          dataByLabel[element.displayname].push({
            monthandyear: element.monthandyear,
            bill: element.bill,
            run_count: element.run_count ? element.run_count : 0,
          });
        });
        templables = [...new Set(templables)];
        for (const [label, items] of Object.entries(dataByLabel)) {
          if (label !== "") {
            const dataset = {
              label: label,
              data: templables.map((month) => {
                const item = items.find((i) => i.monthandyear === month);
                return item ? item.bill : 0;
              }),
              backgroundColor: commonservices.CreateColor(label)?.BGColor,
              run_count: templables.map((month) => {
                const item = items.find((i) => i.monthandyear === month);
                return item ? item.run_count : 0;
              })
            };
            tempdatasets.push(dataset);
          }
        }
        setChartReportData({
          labels: templables,
          datasets: tempdatasets,
        });
      } else {
        setChartReportData({
          labels: [],
          datasets: [],
        });
      }
    } catch (error) {
    } finally {
      setChartReportLoader(false);
    }
  }
  const getTimeZoneObj = (timezone) => {
    let filterdData = TIMEZONE_LIST?.filter((x) => x?.value === timezone);

    return filterdData;
  };

  const getBlogList = async () => {
    try {
      let response = await axios({
        method: "GET",
        url: `${API_URL.WORDPRESS.GET_BLOG_LIST}?per_page=10&page=1`,
      });
      setBlogList(response?.data?.posts);
    } catch (error) {
      setBlogList(null);
    }
  };

  const getDataCloudHealth = async () => {
    const currentDate = new Date().toLocaleDateString("en-CA", {
      timeZone: browserTimezone,
    });

    setDataCloudHealthLoader(true);
    dispatch(getDataCloudHealthCount({ currentdate: currentDate, timezone: browserTimezone }))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setDataCloudHealthCount(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setDataCloudHealthCount(null);
        }
      })
      .finally(() => {
        setDataCloudHealthLoader(false);
      });
  };

  const NewsDataList = useSelector(
    (state) => state?.blogredux?.BlogGetListNewsData?.data?.data?.data,
  );

  const GetNewsData = () => {
    dispatch(BlogGetListNews({ pagesize: 10, pagenumber: 1 }));
  };

  const getPaymentMethodList = async () => {
    const body = {};
    dispatch(PaymentMethodList(body))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setPaymentMethodList(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setPaymentMethodList(null);
        }
      })
      .finally(() => { });
  };

  const getWorkflowStatistics = async () => {
    const body = {
      startdate: new Date().toISOString(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
    dispatch(GetWorkflowStatistics(body))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setworkflowStatistics(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setworkflowStatistics(null);
        }
      })
      .finally(() => { });
  };

  const getWorkflowStatisticsCount = async () => {
    setWorkflowStatisticsCountLoader(true);
    const currentDate = new Date().toLocaleDateString("en-CA", {
      timeZone: browserTimezone,
    });

    dispatch(
      GetDashboardTodayWorkflowStatisticsCount({
        currentdate: currentDate,
        timezone: browserTimezone,
      }),
    )
      .then((response) => {
        if (response?.payload?.isValidate) {
          setWorkflowStatisticsCount(response?.payload?.data?.data?.datalist1?.[0] || null);
          setWorkflowStatisticsCountLoader(false);
        }
        if (!response?.payload?.isValidate) {
          setWorkflowStatisticsCount(null);
          setWorkflowStatisticsCountLoader(false);
        }
      })
      .finally(() => {
        setWorkflowStatisticsCountLoader(false);
      });
  };

  const getDailyActivityCahrtData = async (selectedyear, selectedmonth) => {
    const pad = (value) => String(value).padStart(2, "0");
    const startDate = `${selectedyear}-${pad(selectedmonth)}-01`;
    const endDate = `${selectedyear}-${pad(selectedmonth)}-${new Date(
      selectedyear,
      selectedmonth,
      0,
    ).getDate()}`;
    const body = {
      startdate: startDate,
      enddate: endDate,
      searchText: searchValue,
      timezone: browserTimezone,
    };
    dispatch(getDashboardDailyActivityData(body))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setDailyActivityChartReportdata(response?.payload?.data?.data);
          setDailyActivityChartReportLoader(false);
        }
        if (!response?.payload?.isValidate) {
          setDailyActivityChartReportdata(null);
          setDailyActivityChartReportLoader(true);
        }
      })
      .finally(() => { });
  };
  const [showAll, setShowAll] = useState(false);
  const [showLegendModal, setShowLegendModal] = useState(false);
  const [legendDatasets, setLegendDatasets] = useState([]);
  const [hiddenDatasets, setHiddenDatasets] = useState(new Set());
  const [legendSearchTerm, setLegendSearchTerm] = useState('');

  const Billing_options = React.useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    onClick: (event, elements) => {
      if (elements && elements.length > 0) {
        const element = elements[0];
        const index = element.index;
        const clickedLabel = ChartReportData.labels[index];

        if (BillingDrilldownData && BillingDrilldownData.length > 0) {
          let templables = [];
          let tempdatasets = [];
          let dataByLabel = {};

          let FilterData = BillingDrilldownData.filter(
            (d) => d.monthandyear === clickedLabel,
          );

          if (FilterData && FilterData.length > 0) {
            FilterData.forEach((element) => {
              templables.push(element.days);
              let displayname = element.displayname ? element.displayname : "-";
              if (!dataByLabel[displayname]) {
                dataByLabel[displayname] = [];
              }
              dataByLabel[displayname].push({
                days: element.days,
                bill: element.bill ? element.bill : 0,
                run_count: element.run_count ? element.run_count : 0,
              });
            });
            templables = [...new Set(templables)];
            for (const [label, items] of Object.entries(dataByLabel)) {
              if (label !== "") {
                const dataset = {
                  label: label,
                  data: templables.map((days) => {
                    const item = items.find((i) => i.days === days);
                    return item ? item.bill : 0;
                  }),
                  backgroundColor: commonservices.CreateColor(label)?.BGColor,
                  run_count: templables.map((days) => {
                    const item = items.find((i) => i.days === days);
                    return item ? item.run_count : 0;
                  }),
                };
                tempdatasets.push(dataset);
              }
            }
            setDrilldownChartReportData({
              labels: templables,
              datasets: tempdatasets,
              clickedLabel: clickedLabel,
            });
            setIsShowDrilldownChart(true);
          }
        }
      }
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 12,
          boxHeight: 12,

          filter: (legendItem, chartData) => {
            if (!showAll) {
              if (legendItem.datasetIndex <= 4) {
                return true;
              }
              return legendItem.text === "Show More...";
            }
            return true;
          },
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;

            const defaultLabels = datasets.map((dataset, index) => ({
              text: dataset.label,
              fillStyle: dataset.backgroundColor,
              hidden: !chart.isDatasetVisible(index),
              datasetIndex: index,
            }));

            defaultLabels.push({
              text: showAll ? "Show Less..." : "Show More...",
              fillStyle: "#999",
              strokeStyle: "#999",
              lineWidth: 0,
              datasetIndex: -1,
            });
            return defaultLabels;
          },
        },
        onClick: (e, legendItem, legend) => {
          if (
            legendItem.text === "Show More..." ||
            legendItem.text === "Show Less..."
          ) {
            // Always refresh chart instance reference (it changes after drilldown navigation)
            window.chartInstance = { chartInstance: legend.chart };
            // Open legend modal
            const datasets = legend.chart.data.datasets.map((dataset, index) => ({
              label: dataset.label,
              color: dataset.backgroundColor,
              visible: legend.chart.isDatasetVisible(index),
              index: index,
            }));
            setLegendDatasets(datasets);
            setShowLegendModal(true);
            return;
          }
          ChartJS.defaults.plugins.legend.onClick.call(
            this,
            e,
            legendItem,
            legend,
          );
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
        enabled: false,
        external: externalTooltipHandler,

        callbacks: {
          title: (tooltipItems) => tooltipItems[0].label,

          label: (tooltipItem) => {
            const value = tooltipItem.raw;

            if (!value || value <= 0) return null;
            const runCount =
              tooltipItem.dataset.run_count?.[tooltipItem.dataIndex] ?? 0;

            return `${tooltipItem.dataset.label}(${runCount}): $${Number(value).toFixed(4)}`;
          },

          footer: (tooltipItems) => {
            const total = tooltipItems
              .map((item) => item.raw || 0)
              .reduce((sum, val) => sum + val, 0);

            return total > 0 ? `Total: $${Number(total).toFixed(4)}` : null;
          },
        },
      },
    },
    barThickness: 40,
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: (value) => `$${value}`,
        },
        grid: {
          display: true,
          color: "#F1F1F1",
        },
      },
    },
  }), [showAll, ChartReportData, ChartReportHandle, BillingDrilldownData]);

  useEffect(() => {
    getBlogList();
    GetToolbarData();
    getDataCloudHealth();
    getAllMachineList();
    fngetCostwidgetdata();
    GetNewsData();
    getPaymentMethodList();
    getWorkflowStatistics();
    getWorkflowStatisticsCount();
  }, []);

  function fnHandleRadio(e) {
    const { checked, value } = e.target;
    if (checked) {
      setChartReportHandle({
        ...ChartReportHandle,
        ["databy"]: value,
      });
    }
  }

  // useEffect(() => {
  //   setDailyActivityChartReportLoader(true);
  //   getDailyActivityCahrtData(
  //     DailyActivityChartReportHandle.year,
  //     DailyActivityChartReportHandle.month,
  //   );
  // }, [DailyActivityChartReportHandle]);

  // useEffect(() => {
  //   fngetChartReport(ChartReportHandle?.year, ChartReportHandle?.databy);
  // }, [ChartReportHandle]);


  useEffect(() => {
    if (callApi) {
      getWorkFlowList();

      setDailyActivityChartReportLoader(true);
      getDailyActivityCahrtData(
        DailyActivityChartReportHandle.year,
        DailyActivityChartReportHandle.month,
      );
    }
  }, [callApi, debouncingValue, DailyActivityChartReportHandle]);

  useEffect(() => {
    if (callApi) {
      // Any filter/search refresh should bring user back to the main monthly chart.
      setIsShowDrilldownChart(false);
      fngetChartReport(ChartReportHandle?.year, ChartReportHandle?.databy);
    }
  }, [callApi, debouncingValue, ChartReportHandle]);

  const GetToolbarData = async () => {
    try {
      let response = await axios({
        method: "GET",
        url: "https://quantumdatalytica.com/wp-json/custom/v1/use-cases/",
      });
      setToolBarList(response?.data);
    } catch (error) {
      setToolBarList(null);
    }
  };

  const checkUserIsReviewer = () => {
    let isReviewer = false;
    if (checkUserType?.associationtype === "Reviewers") {
      isReviewer = true;
    }
    return isReviewer;
  };
  const checkUserIsContact = () => {
    let isContact = false;
    if (checkUserType?.associationtype === "Contacts") {
      isContact = true;
    }
    return isContact;
  };

  return (
    <div className="dashboard-main">
      <Walkthrough
        callback={handleWalkthroughCallback}
        steps={steps}
        run={!callApi}
        keyName="workflowDashboard"
      />
      <div className="all-page-top all-main-Background-image">
        <Container>
          <div className="top-section-all dashboard-top-section">
            <div className="top-section-left">
              <h1>Welcome to Data Cloud</h1>
              <p>
                Where information transforms into innovation, insights
                illuminate, and possibilities abound in the digital realm.
              </p>
            </div>
            <div className="top-section-right">
              <Carousel fade interval="2000">
                {toolBarList?.map((item, index) => {
                  return (
                    <Carousel.Item key={index}>
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          window.open(item && item?.link, "_blank");
                        }}
                      >
                        <div className="slide-content-main">
                          <img src={item && item?.icon} alt="plane" />
                          <div>
                            <h3>{item && item?.title}</h3>
                            <p>{item && item?.description}</p>
                          </div>
                        </div>
                      </div>
                    </Carousel.Item>
                  );
                })}

                {/* <Carousel.Item>
                        <div>
                            <div className="slide-content-main">
                            <img src={plane} alt="plane" />
                            <div>
                                <h3>High Occupancy 09/06/2024</h3>
                                <p>
                                Date Specific: 09/06/2024 shows a high occupancy rate
                                of 84% but ADR of $90, which is lower to other high
                                occupancy dates.
                                </p>
                            </div>
                            </div>
                        </div>
                        </Carousel.Item>
                        <Carousel.Item>
                        <div>
                            <div className="slide-content-main">
                            <img src={plane} alt="plane" />
                            <div>
                                <h3>RevPAR</h3>
                                <p>
                                RevPAR (Revenue Per Available Room): The RevPAR is low
                                due to low occupancy rates. For example, on June 23,
                                the RevPAR is $12.
                                </p>
                            </div>
                            </div>
                        </div>
                        </Carousel.Item> */}
              </Carousel>
            </div>
          </div>
          <div className="main-dashboard-grid">
            <div className="d-flex flex-column gap-3">
              <div className="top-bot-section workflow-tab mt-0">
                <div className="header-search-input searchplaceholder d-flex gap-2 align-items-center">
                  <h6 className="text-nowrap">
                    Workflows
                    {WorkFlowLastDataList &&
                      WorkFlowLastDataList?.length > 0 &&
                      ` (${WorkFlowLastDataList?.length})`}
                  </h6>
                  <InputGroup>
                    <InputGroup.Text id="basic-addon1">
                      <img
                        src={searchicon}
                        alt="searchicon"
                        className="cursor-pointer"
                      />
                    </InputGroup.Text>
                    <Form.Control
                      placeholder={`Search Workflow`}
                      aria-label="Search"
                      aria-describedby="basic-addon1"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                  </InputGroup>
                </div>
              </div>
              <div className="dashboard-stacked-chart common-white-bg">
                <div className="chart-title">
                  <div className="d-flex align-items-center gap-3">
                    <h5>Your Assign Workflow Daily Activity</h5>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Form.Select
                      style={{ minWidth: "80px" }}
                      value={DailyActivityChartReportHandle.month}
                      onChange={(e) => {
                        setDailyActivityChartReportHandle({
                          ...DailyActivityChartReportHandle,
                          ["month"]: parseInt(e.target.value),
                        });
                      }}
                      aria-label="Default select example"
                    >
                      {MonthsArrayList?.map((item, index) => {
                        return (
                          <option key={index} value={item?.number}>
                            {item?.short}
                          </option>
                        );
                      })}
                    </Form.Select>
                    <Form.Select
                      style={{ minWidth: "80px" }}
                      onChange={(e) =>
                        setDailyActivityChartReportHandle({
                          ...DailyActivityChartReportHandle,
                          ["year"]: parseInt(e.target.value),
                        })
                      }
                      aria-label="Default select example"
                    >
                      {commonservices.fnLastYearList(5).map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
                {DailyActivityChartReportLoader ? (
                  <div className="my-2">
                    <Loader type={LoaderType.DailyActivityChartLine} />
                  </div>
                ) : (
                  <div className="dashboard-stacked-chart-main-chart-wrapper">
                    {dailyActivityChartReportdata?.length > 0 ? (
                      <DailyActivityChart data={dailyActivityChartReportdata} selectedmonth={DailyActivityChartReportHandle.month} selectedyear={DailyActivityChartReportHandle.year} />
                    ) : (
                      <div className="d-flex h-100 justify-content-center align-items-center">
                        <Nodata />
                      </div>
                    )}
                  </div>
                )}
              </div>
              <>
                {!IsShowDrilldownChart ? (
                  <div className="dashboard-stacked-chart common-white-bg">
                    <div className="chart-title">
                      <div className="d-flex align-items-center gap-3">
                        <h5>Your Assign Workflow Billing By Month</h5>
                        <div className="d-flex align-items-center gap-3">
                          <Form.Check
                            type="radio"
                            id="workflow"
                            label="Workflow"
                            name="workflow"
                            value="workflow"
                            checked={ChartReportHandle.databy === "workflow"}
                            onChange={(e) => fnHandleRadio(e)}
                          />
                          <Form.Check
                            type="radio"
                            id="machine"
                            label="Machine"
                            name="machine"
                            value="machine"
                            checked={ChartReportHandle.databy === "machine"}
                            onChange={(e) => fnHandleRadio(e)}
                          />
                        </div>
                      </div>
                    </div>
                    {ChartReportLoader ? (
                      <div className="my-2">
                        <Loader type={LoaderType.ChartLine} />
                      </div>
                    ) : (
                      <div className="dashboard-stacked-chart-main-chart-wrapper" style={{ position: 'relative' }}>
                        {ChartReportData?.datasets?.length > 0 ? (
                          <Bar
                            ref={chartRef}
                            data={ChartReportData}
                            options={Billing_options}
                          />
                        ) : (
                          <div className="d-flex h-100 justify-content-center align-items-center">
                            <Nodata />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="dashboard-stacked-chart common-white-bg">
                    <div className="chart-title">
                      <div className="d-flex align-items-center gap-3">
                        <h5>Your Assign Workflow Billing By Date - {ChartReportHandle.databy === 'workflow' ? 'Workflow' : 'Machine'}</h5>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={arrowleft}
                          alt="listicon"
                          className="cursor-pointer"
                          onClick={(e) => setIsShowDrilldownChart(false)}
                        />
                      </div>
                    </div>
                    <div className="dashboard-stacked-chart-main-chart-wrapper">
                      <StackedBarChart data={DrilldownChartReportData} />
                    </div>
                  </div>
                )}
              </>

              <div className="top-bot-section workflow-tab mt-0 dashboard-table-top-section pb-0">
                <div className="custom-tabing tourWorkFlowDashboardTab singledesh-tab">
                  <div
                    className={
                      activeTab === 1 ? "single-tab active" : "single-tab"
                    }
                    onClick={() => handleTabClick(1)}
                  >
                    <img src={cardicon} alt="cardicon" />
                    <span>Card</span>
                  </div>
                  <div
                    className={
                      activeTab === 0 ? "single-tab active" : "single-tab"
                    }
                    onClick={() => handleTabClick(0)}
                  >
                    <img src={listicon} alt="listicon" />
                    <span>List</span>
                  </div>
                </div>
                <div className="top-bot-right-section">
                  <div className="d-flex gap-3 justify-content-end">
                    <div className="listcolor">
                      <div className="listcolor-block">
                        <div
                          className="listcolor-icon"
                          style={{ backgroundColor: "#75BDE7" }}
                        ></div>
                        <div className="listcolor-detail">
                          <p>CPU Usage</p>
                        </div>
                      </div>
                      <div className="listcolor-block">
                        <div
                          className="listcolor-icon"
                          style={{ backgroundColor: "#BC6CD4" }}
                        ></div>
                        <div className="listcolor-detail">
                          <p>Memory Usage</p>
                        </div>
                      </div>
                      <div className="listcolor-block">
                        <div
                          className="listcolor-icon"
                          style={{ backgroundColor: "#D89965" }}
                        ></div>
                        <div className="listcolor-detail">
                          <p>Network Usage</p>
                        </div>
                      </div>
                    </div>
                    {roleAccess?.iscreate && (
                      <>
                        <div
                          className="filtering-main position-relative tourWorkFlowDashboardAdd"
                          id="add-project"
                          onClick={(e) => {
                            e.preventDefault();
                            handleOverlay(e);
                            setShow(!show);
                            handleshowAddProjectPopup();
                          }}
                          ref={target}
                        >
                          <img src={addicon} alt="filtericon" />
                          <span>Add</span>
                        </div>
                        {/* </Link> */}
                        {showAddProjectPopup ? (
                          <>
                            <Overlay
                              target={target.current}
                              show={showAddProjectPopup}
                              placement="bottom"
                            >
                              {(props) => (
                                <Tooltip id="overlay-example" {...props}>
                                  <AddProjectPopup
                                    handleshowPopup={handleshowAddProjectPopup}
                                    activeTab={activeTab}
                                  />
                                </Tooltip>
                              )}
                            </Overlay>
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="main-page-content">
                {" "}
                {activeTab === 0 ? (
                  <>
                    <div className="table-wrapper-main">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th className="width250 sticky-workflow">
                              Workflow Name
                            </th>
                            <th className="text-center">Runs</th>
                            <th className="text-center">Results</th>
                            <th className="text-center">Machine</th>
                            {/* <th className="width125">Active</th> */}
                            <th className=" text-center text-nowrap">
                              Last Run
                            </th>
                            <th className="text-center text-nowrap">
                              next schedule
                            </th>
                            <th className="">status</th>
                            <th className="">Workspace</th>
                            <th className="text-end width140">billing</th>
                            <th className="width160 text-center">CPU Usage</th>
                            <th className="width160 text-center">
                              Memory Usage
                            </th>
                            <th className="width160 text-center">
                              Network Usage
                            </th>
                            <th className="text-end sticky-actions">Action</th>
                          </tr>
                          {/* <tr>
                                <th className="width250 sticky-workflow">
                                Workflow Name
                                </th>
                                <th className="width160 text-center">Runs</th>
                                <th className="width160 text-center">Results</th>
                                <th className="width160 text-center">Machine</th>
                                
                                <th className=" text-center width235">Last Run</th>
                                <th className="text-center width235">next schedule</th>
                                <th className="width260">status</th>
                                <th className="text-center width100">billing</th>
                                <th className="width280 text-center">CPU Usage</th>
                                <th className="width280 text-center">Memory Usage</th>
                                <th className="width280 text-center">Network Usage</th>
                                <th className="text-end sticky-actions">Action</th>
                            </tr> */}
                        </thead>
                        <tbody>
                          {loading ? (
                            <Loader
                              type={LoaderType.TableRow}
                              count={5}
                              nooftd={12}
                            />
                          ) : (
                            <>
                              {WorkFlowLastDataList?.length > 0 ? (
                                WorkFlowLastDataList?.map((item) => {
                                  let timeZone = getTimeZoneObj(
                                    item?.timezone ? item?.timezone : "",
                                  );
                                  const workspaces = item?.workspacename
                                    ? item.workspacename
                                      .split(",")
                                      .map((w) => w.trim())
                                    : [];
                                  return (
                                    <tr key={item?.workflowid}>
                                      <td
                                        className="theme-color-text fw600 sticky-workflow"
                                        title={item?.workflowname}
                                      >
                                        <span
                                          onClick={() => {
                                            let data =
                                              commonservices.bodyEncryption(
                                                `${item?.workflowid}?v=1&r=dl`,
                                              );
                                            // navigate(`/flow-new/${data}`, {
                                            //   state: {
                                            //     isViewMode: true,
                                            //     flowRoleRights: item,
                                            //   },
                                            // });
                                            navigate(`/flow-new-view/${data}`, {
                                              state: {
                                                isViewMode: true,
                                                flowRoleRights: item,
                                              },
                                            });
                                          }}
                                          style={{ cursor: "pointer" }}
                                        >
                                          {commonservices.truncateText(
                                            item?.workflowname,
                                            30,
                                          )}
                                        </span>
                                      </td>
                                      <td className="text-center">
                                        {(item?.totalsuccessed
                                          ? item?.totalsuccessed
                                          : 0) +
                                          (item?.totalfailed
                                            ? item?.totalfailed
                                            : 0)}
                                      </td>

                                      <td className="text-center">
                                        <span className="green-color-text-sucess">
                                          {item?.totalsuccessed
                                            ? item?.totalsuccessed
                                            : 0}
                                        </span>
                                        <span className="red-color-text">
                                          /
                                          {item?.totalfailed
                                            ? item?.totalfailed
                                            : 0}
                                        </span>
                                      </td>
                                      <td className="text-center">
                                        {item?.totalmachine
                                          ? item?.totalmachine
                                          : 0}
                                      </td>
                                      {/* <td>
                                            {commonservices.getStatus(
                                            item?.argoworkflowstatus
                                            )}
                                        </td> */}
                                      <td className="text-center text-nowrap">
                                        {item?.lastrunon
                                          ? commonservices.convertTimeToLocal(
                                            item?.lastrunon,
                                          )
                                          : ""}{" "}
                                        <span style={{ fontSize: "9px" }}>
                                          {/* {item?.lastrunon
                                                ? timeZone?.[0]?.shortValue
                                                : ""}{" "} */}
                                          {item?.lastrunon
                                            ? commonservices.convertDateToLocal(
                                              item?.lastrunon,
                                            )
                                            : ""}{" "}
                                        </span>
                                      </td>
                                      {/* <td className="text-center">
                                            {item?.lastrunon
                                            ? commonservices.convertDateToLocal(
                                                item?.lastrunon
                                                )
                                            : ""}{" "}
                                            {item?.lastrunon
                                            ? commonservices.convertTimeToLocal( 
                                                item?.lastrunon
                                                )
                                            : ""}
                                        </td> */}
                                      {/* <td className="text-center">
                                            {item?.argoworkflowstatus === "Active" &&
                                            item?.nextrunon
                                            ? commonservices.convertDateToLocal(
                                                item?.nextrunon
                                                )
                                            : ""}{" "}
                                            {item?.argoworkflowstatus === "Active" &&
                                            item?.nextrunon
                                            ? commonservices.convertTimeToLocal(
                                                item?.nextrunon
                                                )
                                            : ""}
                                        </td> */}
                                      <td className="text-center ">
                                        {item?.argoworkflowstatus ===
                                          "Active" && item?.nextrunon
                                          ? commonservices.convertTimeToLocal(
                                            item?.nextrunon,
                                          )
                                          : ""}{" "}
                                        <span style={{ fontSize: "9px" }}>
                                          {/* {item?.argoworkflowstatus === "Active" &&
                                            item?.nextrunon

                                                ? timeZone?.[0]?.shortValue
                                                : ""}{" "} */}
                                          {item?.argoworkflowstatus ===
                                            "Active" && item?.nextrunon
                                            ? commonservices.convertDateToLocal(
                                              item?.nextrunon,
                                            )
                                            : ""}
                                        </span>
                                      </td>
                                      <td>
                                        {/* {commonservices.getStatus(item?.laststatus)} */}
                                        <div className="d-flex">
                                          <div className="mt-1 me-1">
                                            {commonservices.getStatus(
                                              item?.argoworkflowstatus,
                                            )}
                                          </div>
                                          <span className="mt-1">
                                            {commonservices.getWithoutDotStatus(
                                              item?.laststatus,
                                            )}
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        {workspaces.length > 0 && (
                                          <div className="workspace-wrapper p-1 work-space">
                                            <div className="d-flex gap-1 flex-nowrap align-items-center">
                                              <span className="custom-chip chip-maxw">
                                                {workspaces[0]}
                                              </span>

                                              {workspaces.length > 1 && (
                                                <div className="tooltip-wrapper">
                                                  <span className="custom-chip">
                                                    +{workspaces.length - 1}
                                                  </span>

                                                  <div className="tooltip-content">
                                                    {workspaces
                                                      .slice(1)
                                                      .map((ws, idx) => (
                                                        <div key={idx}>
                                                          {ws}
                                                        </div>
                                                      ))}
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                      </td>
                                      <td className="text-end">
                                        $
                                        {item?.totalcost
                                          ? commonservices.fnAmountDigitCount(
                                            item?.totalcost,
                                            5,
                                          )
                                          : 0}
                                      </td>
                                      <td className="dashboard-listing-chart ">
                                        <div className="line-chart-in-table ms-4">
                                          <LineChartWithPointInline
                                            data={
                                              item?.chartdata &&
                                              JSON.parse(item?.chartdata)
                                            }
                                            params={"CPU Usage"}
                                          />
                                        </div>
                                      </td>
                                      <td className="dashboard-listing-chart ">
                                        <div className="line-chart-in-table ms-4">
                                          <LineChartWithPointInline
                                            data={
                                              item?.chartdata &&
                                              JSON.parse(item?.chartdata)
                                            }
                                            params={"Memory Usage"}
                                          />
                                        </div>
                                      </td>
                                      <td className="dashboard-listing-chart ">
                                        <div className="line-chart-in-table ms-4">
                                          <LineChartWithPointInline
                                            data={
                                              item?.chartdata &&
                                              JSON.parse(item?.chartdata)
                                            }
                                            params={"Network Usage"}
                                          />
                                        </div>
                                      </td>
                                      <td className="sticky-actions">
                                        <div className="all-actions">
                                          <img
                                            id={`next${item?.workflowid}`}
                                            src={historyAction}
                                            alt="historyaction"
                                            title="Scheduler"
                                            onClick={(e) => {
                                              e.preventDefault();

                                              targetSchedularRef.current =
                                                document.querySelector(
                                                  `#next${item?.workflowid}`,
                                                );
                                              handleOverlayForScheduler(e);
                                              setShow(!show);
                                              handleshowSchedulerPopup();
                                              SetScheduler(item);
                                            }}
                                            ref={targetScheduler}
                                          />
                                          {/* <img
                                                id={`nextt${item?.workflowid}`}
                                                src={notificationAction}
                                                alt="notificationAction"
                                                title="Notification"
                                                className={
                                                showNotification
                                                    ? "overlay-isopen"
                                                    : ""
                                                }
                                                onClick={(e) => {
                                                e.preventDefault();
                                                target1.current =
                                                    document.querySelector(
                                                    `#nextt${item?.workflowid}`
                                                    );
                                                notificationPayloadRef.current = {
                                                    associationId: item?.workflowid,
                                                    associationType: "workflow",
                                                };
                                                setShowNotification(
                                                    !showNotification
                                                );
                                                handleshowNotification();
                                                }}
                                            /> */}
                                          <span
                                            id={`nextt${item?.workflowid}`}
                                            title="Notification"
                                            className={
                                              showNotification
                                                ? "overlay-isopen notification-blink-btn"
                                                : "notification-blink-btn"
                                            }
                                            onClick={(e) => {
                                              e.preventDefault();
                                              target2.current =
                                                document.querySelector(
                                                  `#nextt${item?.workflowid}`,
                                                );
                                              notificationPayloadRef.current = {
                                                associationId: item?.workflowid,
                                                associationType: "workflow",
                                              };
                                              setShowNotification(
                                                !showNotification,
                                              );
                                              handleshowNotification();
                                            }}
                                          >
                                            <img
                                              src={notification}
                                              alt="Notification"
                                              className="sm-icons"
                                              ref={target2}
                                            // className="sm-icons"
                                            />
                                            {/* <span className="notification-count"></span> */}
                                          </span>
                                          <img
                                            src={actionLog}
                                            alt="actionLog"
                                            title="Log"
                                            onClick={() => {
                                              setModalShow1(true);
                                              setLogId(item?.workflowid);
                                            }}
                                          />
                                          {item?.canview && (
                                            <>
                                              <span
                                                onClick={() => {
                                                  let data =
                                                    commonservices.bodyEncryption(
                                                      `${item?.workflowid}?v=1&r=dl`,
                                                    );
                                                  navigate(
                                                    // `/flow-new/${data}`,
                                                    `/flow-new-view/${data}`,
                                                    {
                                                      state: {
                                                        isViewMode: true,
                                                        flowRoleRights: item,
                                                      },
                                                    },
                                                  );
                                                }}
                                              >
                                                <img
                                                  src={viewAction}
                                                  alt="viewAction"
                                                  title="View"
                                                />
                                              </span>
                                            </>
                                          )}

                                          {item?.canedit && (
                                            <>
                                              <span
                                                onClick={() => {
                                                  let data =
                                                    commonservices.bodyEncryption(
                                                      `${item?.workflowid}?v=0&r=dl`,
                                                    );

                                                  navigate(
                                                    `/flow-new/${data}`,
                                                    // navigate(
                                                    //   `/flow-new/${item?.workflowid}?v=0&r=dl`,
                                                    {
                                                      state: {
                                                        isViewMode: false,
                                                        flowRoleRights: item,
                                                      },
                                                    },
                                                  );
                                                }}
                                              >
                                                <img
                                                  src={editAction}
                                                  alt="editAction"
                                                  title="Edit"
                                                />
                                              </span>
                                            </>
                                          )}

                                          {item?.candelete && (
                                            <img
                                              src={deleteAction}
                                              alt="deleteAction"
                                              title="Delete"
                                              onClick={() => {
                                                setModalShow(true);
                                                setDeletePayload({
                                                  workflowid: item?.workflowid,
                                                  status: "Delete",
                                                });
                                              }}
                                            />
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <>
                                  {/* <td colSpan={100}>
                                        {" "}
                                        <Nodata />
                                    </td> */}
                                </>
                              )}
                            </>
                          )}
                        </tbody>
                      </Table>
                      {((WorkFlowLastDataList &&
                        WorkFlowLastDataList?.length === 0) ||
                        !WorkFlowLastDataList) &&
                        !loading && (
                          <>
                            <Table>
                              <tbody>
                                <tr>
                                  <td>{!loading && <Nodata />}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </>
                        )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="all-dashboard-projects-main">
                      {loading ? (
                        <>
                          <Loader type={LoaderType.ProjectCard} count={8} />
                        </>
                      ) : !callApi ? (
                        dummyWorkflowList?.map((item) => {
                          return (
                            <SingleProjectCard
                              key={item?.workflowid}
                              item={item && { ...item }}
                              projectName={item?.workflowname}
                              cubeNo={
                                item?.totalmachine ? item?.totalmachine : 0
                              }
                              dollarNo={item?.totalcost ? item?.totalcost : 0}
                              lastRunTime={
                                item?.lastrunon
                                  ? commonservices.convertTimeToLocal(
                                    item?.lastrunon,
                                  )
                                  : ""
                              }
                              lastRunDate={
                                item?.lastrunon
                                  ? commonservices.convertDateToLocal(
                                    item?.lastrunon,
                                  )
                                  : ""
                              }
                              nextRunTime={
                                item?.nextrunon
                                  ? commonservices.convertTimeToLocal(
                                    item?.nextrunon,
                                  )
                                  : ""
                              }
                              nextRunDate={
                                item?.nextrunon
                                  ? commonservices.convertDateToLocal(
                                    item?.nextrunon,
                                  )
                                  : ""
                              }
                              activestatus={
                                item?.argoworkflowstatus === "Active"
                                  ? activestatus
                                  : inactivestatus
                              }
                              activestatusLabel={item?.argoworkflowstatus}
                              status={item?.laststatus}
                              code={
                                (item?.totalsuccessed
                                  ? item?.totalsuccessed
                                  : 0) +
                                (item?.totalfailed ? item?.totalfailed : 0)
                              }
                              succeed={
                                item?.totalsuccessed ? item?.totalsuccessed : 0
                              }
                              failed={item?.totalfailed ? item?.totalfailed : 0}
                              workFlowId={item?.workflowid}
                              canView={item?.canview}
                              canedit={item?.canedit}
                              candelete={item?.candelete}
                              callFunction={getWorkFlowList}
                              lastRunCost={
                                item?.lastruncost ? item?.lastruncost : 0
                              }
                              mtdcost={item?.mtd ? item?.mtd : 0}
                              handleshowtypeclick={handleshowtypeclick}
                              getTargetRef={getTargetRef}
                            />
                          );
                        })
                      ) : WorkFlowLastDataList?.length > 0 ? (
                        WorkFlowLastDataList?.map((item) => {
                          return (
                            <SingleProjectCard
                              key={item?.workflowid}
                              item={{ ...item }}
                              projectName={item?.workflowname}
                              // cubeNo={Math.floor(1 + Math.random() * 9)}
                              cubeNo={
                                item?.totalmachine ? item?.totalmachine : 0
                              }
                              dollarNo={item?.totalcost ? item?.totalcost : 0}
                              lastRunTime={
                                item?.lastrunon
                                  ? commonservices.convertTimeToLocal(
                                    item?.lastrunon,
                                  )
                                  : ""
                              }
                              lastRunDate={
                                item?.lastrunon
                                  ? commonservices.convertDateToLocal(
                                    item?.lastrunon,
                                  )
                                  : ""
                              }
                              nextRunTime={
                                item?.nextrunon
                                  ? commonservices.convertTimeToLocal(
                                    item?.nextrunon,
                                  )
                                  : ""
                              }
                              nextRunDate={
                                item?.nextrunon
                                  ? commonservices.convertDateToLocal(
                                    item?.nextrunon,
                                  )
                                  : ""
                              }
                              activestatus={
                                item?.argoworkflowstatus === "Active"
                                  ? activestatus
                                  : inactivestatus
                              }
                              activestatusLabel={item?.argoworkflowstatus}
                              status={item?.laststatus}
                              code={
                                (item?.totalsuccessed
                                  ? item?.totalsuccessed
                                  : 0) +
                                (item?.totalfailed ? item?.totalfailed : 0)
                              }
                              succeed={
                                item?.totalsuccessed ? item?.totalsuccessed : 0
                              }
                              failed={item?.totalfailed ? item?.totalfailed : 0}
                              workFlowId={item?.workflowid}
                              canView={item?.canview}
                              canedit={item?.canedit}
                              candelete={item?.candelete}
                              callFunction={getWorkFlowList}
                              lastRunCost={
                                item?.lastruncost ? item?.lastruncost : 0
                              }
                              mtdcost={item?.mtd ? item?.mtd : 0}
                              handleshowtypeclick={handleshowtypeclick}
                              getTargetRef={getTargetRef}
                            />
                          );
                        })
                      ) : (
                        <>{!loading && <Nodata />}</>
                      )}
                    </div>
                  </>
                )}
              </div>


              <div className="all-services-section common-white-bg">
                <div className="chart-title">
                  <h5>All Machines</h5>

                  {!checkUserIsReviewer() && !checkUserIsContact() && (
                    <span
                      onClick={(e) => {
                        navigate("/management-listing", {
                          state: "purchases",
                        });
                      }}
                      className="crossarrow"
                    >
                      <img src={crossarrow} alt="crossarrow" />
                    </span>
                  )}
                </div>
                {getAllMachineLoader ? (
                  <Loader type={LoaderType.AllMachineWidget} count={2} />
                ) : MyPurchaseList?.length > 0 ? (
                  <>
                    <div className="all-services-wrapper">
                      {MyPurchaseList.slice(0, 8)?.map((item, index) => (
                        <div
                          className="single-service-main cursor-pointer"
                          key={index}
                          onClick={() =>
                            navigate(
                              `/marketplace/marketplace-detail/${commonservices.bodyEncryption(
                                String(item?.machineid),
                              )}/Marketplace`,
                            )
                          }
                          title={item?.machinename}
                        >
                          <div className="service-icon">
                            <img
                              src={
                                item?.machinelogo !== "" &&
                                  item?.machinelogo !== null
                                  ? item?.machinelogo
                                  : DemoLogo
                              }
                              alt="machinelogo"
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = DemoLogo;
                              }}
                            />
                          </div>
                          <div>
                            <h4>{item?.machinename}</h4>
                            {/* <p>{item?.shortdescription}</p> */}

                            <p
                              dangerouslySetInnerHTML={{
                                __html: item?.shortdescription,
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="d-flex h-100 justify-content-center align-items-center">
                    <Nodata />
                  </div>
                )}
              </div>

              <div className="datafactory-dashboard-data">
                <div className="common-white-bg h-100">
                  <div className="chart-title mb-2">
                    <h5>Latest Announcements</h5>
                    <Link to="/announcements" className="crossarrow">
                      <img src={crossarrow} alt="crossarrow" />
                    </Link>
                  </div>
                  <div className="all-annoncements">
                    {getAllMachineLoader ? (
                      <Loader type={LoaderType.AllAnnouncements} />
                    ) : (
                      NewsDataList?.map((item, index) => {
                        return (
                          <div
                            className="single-announcement cursor-pointer"
                            key={index}
                          // onClick={() => {
                          //   navigate("/announcement", {
                          //     state: { id: item?.latestnewsid },
                          //   });
                          // }}
                          >
                            <h3>{item?.title}</h3>
                            <p>{item?.shortdescription}</p>
                            <div className="d-flex align-items-center gap-1">
                              <img
                                src={calendar}
                                alt="calendar"
                                className="xsm-icons"
                              />
                              <span>
                                {item?.dateofpublished &&
                                  commonservices.convertDateToLocal(
                                    item?.dateofpublished,
                                  )}
                              </span>
                            </div>
                          </div>
                        );
                      })
                    )}

                    {/* <div className="single-announcement">
                        <h3>Celebrating 1 Million Data Cloud Users</h3>
                        <p>
                        We're excited to announce the latest enhancements to the
                        Data Cloud platform! Our team has been hard at work to
                        bring you advanced features that elevate your Our team has
                        been hard at work to bring you advanced features that
                        elevate your ...
                        </p>
                        <div className="d-flex align-items-center gap-1">
                        <img
                            src={calendar}
                            alt="calendar"
                            className="xsm-icons"
                        />
                        <span>12-15-2024</span>
                        </div>
                    </div> */}
                  </div>
                </div>
                <div className="common-white-bg recent-data h-100">
                  <div className="chart-title mb-2">
                    <h5>Recent data Cloud blogs</h5>
                    <Link
                      to="https://quantumdatalytica.com/blogs/"
                      className="crossarrow"
                      target="_blank"
                    >
                      <img src={crossarrow} alt="crossarrow" />
                    </Link>
                  </div>
                  <div className="all-dashboard-blogs ">
                    {blogList?.map((item, index) => {
                      return (
                        <Link
                          to={item?.read_more}
                          target="_blank"
                          key={item?.title}
                        >
                          <div
                            className={`single-dashboard-blog single-costing-box common-white-bg mw-100`}
                          >
                            <h5>{item?.title ? item?.title : ""}</h5>
                            <p>{item?.description ? item?.description : ""}</p>
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center gap-2">
                                <img
                                  src={
                                    item?.author_image
                                      ? item?.author_image
                                      : profilepic1
                                  }
                                  alt="author"
                                  className="small-profile-pic"
                                  onError={({ currentTarget }) => {
                                    currentTarget.onerror = null;
                                    currentTarget.src = profilepic1;
                                  }}
                                />

                                <Link
                                  to={item?.author_profile_url}
                                  target="_blank"
                                >
                                  <span>
                                    {item?.author_name ? item?.author_name : ""}
                                  </span>
                                </Link>
                              </div>
                              <div className="d-flex align-items-center gap-1">
                                <img
                                  src={calendar}
                                  alt="calendar"
                                  className="xsm-icons"
                                />
                                <span>
                                  {item?.date
                                    ? commonservices.getDateInFormat(item?.date)
                                    : ""}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="dashboard-right-box d-flex flex-column gap-3">
              <div className="common-white-bg">
                <div className="chart-title">
                  <h5>Workflow Statistics</h5>
                </div>
                <div className="workflow-wrapper position-relative">
                  <div className="donut">
                    <svg
                      width="224"
                      height="224"
                      viewBox="0 0 224 224"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs>
                        <path
                          id="todayArc"
                          d="M112 20 A100 100 0 0 1 205 112"
                        />

                        <path
                          id="tomorrowArc"
                          d="M112 212 A100 100 0 0 0 212 112"
                        />

                        <path id="weekArc" d="M12 112 A100 100 0 0 0 120 210" />

                        <path id="monthArc" d="M20 112 A100 100 0 0 1 112 20" />

                        <path id="activeArc" d="M112 58 A60 60 0 0 1 129 172" />

                        <path
                          id="suspendedArc"
                          d="M40 141 A55 27 14 0 0 151 127"
                        />
                        <path id="draftedArc" d="M180 88 A33 27 2 0 0 57 124" />
                      </defs>

                      {/* OUTER RING */}
                      <circle
                        cx="112"
                        cy="112"
                        r="94"
                        fill="none"
                        stroke="#E50914"
                        strokeWidth="35"
                        strokeDasharray="157 471"
                        strokeDashoffset="2"
                        transform="rotate(-90 112 112)"
                      />

                      <circle
                        cx="112"
                        cy="112"
                        r="94"
                        fill="none"
                        stroke="#2196F3"
                        strokeWidth="35"
                        strokeDasharray="157 471"
                        strokeDashoffset="-155"
                        transform="rotate(-90 112 112)"
                      />

                      <circle
                        cx="112"
                        cy="112"
                        r="94"
                        fill="none"
                        stroke="#4CAF50"
                        strokeWidth="35"
                        strokeDasharray="149 471"
                        strokeDashoffset="-295"
                        transform="rotate(-90 112 112)"
                      />

                      <circle
                        cx="112"
                        cy="112"
                        r="94"
                        fill="none"
                        stroke="#26C6DA"
                        strokeWidth="35"
                        strokeDasharray="157 471"
                        strokeDashoffset="-444"
                        transform="rotate(-90 112 112)"
                      />

                      {/* OUTER TEXT */}
                      <text className="outer-text">
                        <textPath
                          href="#todayArc"
                          startOffset="50%"
                          textAnchor="middle"
                          fontSize="12"
                          fill="#ffffff"
                        >
                          <tspan fontWeight="800" fontSize="14">
                            {workflowStatistics?.datalist1?.[0]?.today}
                          </tspan>
                          <tspan dx="4">(Today)</tspan>
                        </textPath>
                      </text>

                      <text className="outer-text">
                        <textPath
                          href="#tomorrowArc"
                          startOffset="50%"
                          textAnchor="middle"
                          fontSize="12"
                          fill="#ffffff"
                        >
                          <tspan fontWeight="800" fontSize="14">
                            {workflowStatistics?.datalist1?.[0]?.tomorrow}
                          </tspan>
                          <tspan dx="4">(Tomorrow)</tspan>
                        </textPath>
                      </text>

                      <text className="outer-text">
                        <textPath
                          href="#monthArc"
                          startOffset="50%"
                          textAnchor="middle"
                          fontSize="12"
                          fill="#ffffff"
                        >
                          <tspan fontWeight="800" fontSize="14">
                            {workflowStatistics?.datalist1?.[0]?.month}
                          </tspan>
                          <tspan dx="4">(Month)</tspan>
                        </textPath>
                      </text>

                      <text className="outer-text">
                        <textPath
                          href="#weekArc"
                          startOffset="50%"
                          textAnchor="middle"
                          fontSize="12"
                          fill="#ffffff"
                        >
                          <tspan fontWeight="800" fontSize="14">
                            {workflowStatistics?.datalist1?.[0]?.week}
                          </tspan>
                          <tspan dx="4">(Week)</tspan>
                        </textPath>
                      </text>

                      {/* MIDDLE RING */}
                      <g id="middle-circle-group">
                        <circle
                          cx="112"
                          cy="112"
                          r="56"
                          fill="none"
                          stroke="#FFD54F"
                          strokeWidth="30"
                          strokeDasharray="117 351"
                          strokeDashoffset="0"
                          transform="rotate(-90 112 112)"
                        />

                        <circle
                          cx="112"
                          cy="112"
                          r="56"
                          fill="none"
                          stroke="#FFECB3"
                          strokeWidth="30"
                          strokeDasharray="117 351"
                          strokeDashoffset="-117"
                          transform="rotate(-90 112 112)"
                        />

                        <circle
                          cx="112"
                          cy="112"
                          r="56"
                          fill="none"
                          stroke="#BDBDBD"
                          strokeWidth="30"
                          strokeDasharray="117 351"
                          strokeDashoffset="-234"
                          transform="rotate(-90 112 112)"
                        />

                        <text className="middle-text">
                          <textPath
                            href="#activeArc"
                            startOffset="28%"
                            textAnchor="middle"
                            fontSize="12"
                          >
                            <tspan fontWeight="800" fill="#000" fontSize="14">
                              {workflowStatistics?.datalist1?.[0]?.totalactive}
                            </tspan>
                            <tspan dx="4">Active</tspan>
                          </textPath>
                        </text>

                        <text className="middle-text">
                          <textPath
                            href="#suspendedArc"
                            startOffset="50%"
                            textAnchor="middle"
                            fontSize="12"
                          >
                            <tspan fontWeight="800" fill="#000" fontSize="14">
                              {workflowStatistics?.datalist1?.[0]?.totalsuspend}
                            </tspan>
                            <tspan dx="4">Suspended</tspan>
                          </textPath>
                        </text>
                        <text className="middle-text">
                          <textPath
                            href="#draftedArc"
                            startOffset="78%"
                            textAnchor="middle"
                            fontSize="12"
                          >
                            <tspan fontWeight="800" fill="#000" fontSize="14">
                              {workflowStatistics?.datalist1?.[0]?.totaldrafted}
                            </tspan>
                            <tspan dx="4">Drafted</tspan>
                          </textPath>
                        </text>
                      </g>

                      {/* CENTER */}
                      <circle cx="112" cy="112" r="36" fill="#111" />

                      <text
                        x="112"
                        y="106"
                        textAnchor="middle"
                        fill="#fff"
                        fontSize="12"
                        fontWeight="600"
                      >
                        Workflow
                      </text>

                      <text
                        x="112"
                        y="124"
                        textAnchor="middle"
                        fill="#fff"
                        fontSize="14"
                        fontWeight="700"
                      >
                        {workflowStatistics?.datalist1?.[0]?.total}
                      </text>
                    </svg>
                  </div>

                  {/* Legend */}
                  <div className="legend">
                    <div>
                      <span className="legend-dot black"></span> Workflow
                    </div>
                    <div>
                      <span className="legend-dot yellow"></span> Active
                    </div>
                    <div>
                      <span className="legend-dot light-yellow"></span>
                      Suspended
                    </div>
                    <div>
                      <span className="legend-dot grey-statistics"></span>
                      Drafted
                    </div>
                    <div>
                      <span className="legend-dot red"></span> Today
                    </div>
                    <div>
                      <span className="legend-dot blue"></span> Tomorrow
                    </div>
                    <div>
                      <span className="legend-dot green"></span> Week
                    </div>
                    <div>
                      <span className="legend-dot cyan"></span> Month
                    </div>
                  </div>
                </div>
              </div>

              {workflowStatisticsCountLoader ? (
                <div className="my-2">
                  <Loader type={LoaderType.DashBlockData} count={4} />
                </div>
              ) : (
                <div className="costing-sec dashblockdata">
                  <div
                    className="all-costing-box"
                    style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: "10px" }}
                  >
                    <div className="single-costing-box common-white-bg d-flex flex-column justify-content-between align-items-center text-center" style={{ minHeight: "104px", padding: "10px 8px", minWidth: 0 }}>
                      <div>
                        <h5 style={{ color: "#22b14c", fontSize: "20px", lineHeight: 1, marginBottom: "2px", fontWeight: 700 }}>
                          {workflowStatisticsCount?.success ? workflowStatisticsCount?.success : 0}
                        </h5>
                        <p style={{ fontSize: "13px", color: "#4a4a4a", marginBottom: 0, lineHeight: 1.1 }}>Success</p>
                      </div>
                      <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#e9f8ee", display: "flex", alignItems: "center", justifyContent: "center", alignSelf: "center" }}>
                        <img src={greenTick} alt="Success" style={{ width: "18px", height: "18px" }} />
                      </div>
                    </div>

                    <div className="single-costing-box common-white-bg d-flex flex-column justify-content-between align-items-center text-center" style={{ minHeight: "104px", padding: "10px 8px", minWidth: 0 }}>
                      <div>
                        <h5 style={{ color: "#f01414", fontSize: "20px", lineHeight: 1, marginBottom: "2px", fontWeight: 700 }}>
                          {workflowStatisticsCount?.partialsuccess ? workflowStatisticsCount?.partialsuccess : 0}
                        </h5>
                        <p style={{ fontSize: "13px", color: "#4a4a4a", marginBottom: 0, lineHeight: 1.1 }}>Failed</p>
                      </div>
                      <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#fdecec", display: "flex", alignItems: "center", justifyContent: "center", alignSelf: "center" }}>
                        <img src={redCross} alt="Failed" style={{ width: "18px", height: "18px" }} />
                      </div>
                    </div>

                    <div className="single-costing-box common-white-bg d-flex flex-column justify-content-between align-items-center text-center" style={{ minHeight: "104px", padding: "10px 8px", minWidth: 0 }}>
                      <div>
                        <h5 style={{ color: "#1f86ff", fontSize: "20px", lineHeight: 1, marginBottom: "2px", fontWeight: 700 }}>
                          {workflowStatisticsCount?.inprogress ? workflowStatisticsCount?.inprogress : 0}
                        </h5>
                        <p style={{ fontSize: "13px", color: "#4a4a4a", marginBottom: 0, lineHeight: 1.1 }}>Running</p>
                      </div>
                      <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#e7f1ff", display: "flex", alignItems: "center", justifyContent: "center", alignSelf: "center" }}>
                        <img src={playblackicon} alt="Running" style={{ width: "18px", height: "18px" }} />
                      </div>
                    </div>

                    <div className="single-costing-box common-white-bg d-flex flex-column justify-content-between align-items-center text-center" style={{ minHeight: "104px", padding: "10px 8px", minWidth: 0 }}>
                      <div>
                        <h5 style={{ color: "#8f8f8f", fontSize: "20px", lineHeight: 1, marginBottom: "2px", fontWeight: 700 }}>
                          {workflowStatisticsCount?.scheduled ? workflowStatisticsCount?.scheduled : 0}
                        </h5>
                        <p style={{ fontSize: "13px", color: "#4a4a4a", marginBottom: 0, lineHeight: 1.1 }}>Scheduled</p>
                      </div>
                      <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#efefef", display: "flex", alignItems: "center", justifyContent: "center", alignSelf: "center" }}>
                        <img src={calendar} alt="Scheduled" style={{ width: "18px", height: "18px" }} />
                      </div>
                    </div>
                  </div>
                </div>

              )}

              <div className="costing-sec tourWorkFlowDashboardCost">
                <h6>Total Cost</h6>
                {CostwidgetdataLoader ? (
                  <Loader type={LoaderType.CostWidget} count={4} />
                ) : (
                  <>
                    <div className="all-costing-box">
                      <div className="single-costing-box common-white-bg mw-100 d-flex flex-column justify-content-between">
                        <h5>
                          $
                          {CostwidgetList?.[0]?.monthtodate
                            ? commonservices.fnAmountDigitCount(
                              CostwidgetList?.[0]?.monthtodate,
                              3,
                            )
                            : 0}
                        </h5>
                        <p>Current Month</p>
                      </div>
                      <div className="single-costing-box common-white-bg mw-100 d-flex flex-column justify-content-between">
                        <h5>
                          $
                          {CostwidgetList?.[0]?.lastmonth
                            ? commonservices.fnAmountDigitCount(
                              CostwidgetList?.[0]?.lastmonth,
                              3,
                            )
                            : 0}
                        </h5>

                        <div className={
                          CostwidgetList[0]?.invoiceid == null
                            ? "justify-content-between align-items-center"
                            : "d-flex justify-content-between align-items-center"
                        }>
                          <p>Last Month</p>
                          {CostwidgetList[0]?.invoiceid == null && CostwidgetList[0]?.totalinvoice > 0 && (
                            <p>(Invoice In-Process)</p>
                          )}

                          {CostwidgetList[0]?.invoiceid != null && (
                            CostwidgetList[0]?.status_term?.toUpperCase() === "UNPAID" ? (
                              <button
                                className="blue-btn w-auto btn-sm"
                                style={{ height: "fit-content" }}
                                onClick={() => {
                                  setPaymentPopup({
                                    show: true,
                                    invoiceitem: CostwidgetList[0],
                                    itemtype: "Workflow Invoice",
                                  });
                                }}
                              >
                                Pay Now
                              </button>
                            ) : (
                              <span className="span-paid-label">PAID</span>
                            )
                          )}
                        </div>
                      </div>
                      <div className="single-costing-box common-white-bg mw-100 d-flex flex-column justify-content-between">
                        <h5>
                          $
                          {CostwidgetList?.[0]?.avgofmonth
                            ? commonservices.fnAmountDigitCount(
                              CostwidgetList?.[0]?.avgofmonth,
                              3,
                            )
                            : 0}
                        </h5>
                        <p>Average Month</p>
                      </div>
                      <div className="single-costing-box common-white-bg mw-100 d-flex flex-column justify-content-between">
                        <h5>
                          $
                          {CostwidgetList?.[0]?.forcasteofmonth
                            ? commonservices.fnAmountDigitCount(
                              CostwidgetList?.[0]?.forcasteofmonth,
                              3,
                            )
                            : 0}
                        </h5>
                        <p>Forecast of Month</p>
                      </div>
                    </div>
                    <div
                      className={
                        CostwidgetList?.[0]?.lastmonthchange <= 0
                          ? "green-warning-sec"
                          : "red-warning-sec"
                      }
                    >
                      <p>
                        <span>
                          <b>
                            {Math.abs(CostwidgetList?.[0]?.lastmonthchange) > 0
                              ? Math.abs(CostwidgetList?.[0]?.lastmonthchange)
                              : 0}
                            %
                          </b>
                        </span>{" "}
                        {CostwidgetList?.[0]?.lastmonthchange <= 0
                          ? "Down"
                          : "Up"}{" "}
                        from last month
                      </p>
                    </div>
                  </>
                )}
              </div>
              <div className="costing-sec dashblockdata">
                <div className="chart-title">
                  <h5>Data Cloud Health</h5>
                  {/* <Link to="/" className="crossarrow">
                  <img src={crossarrow} alt="crossarrow" />
                </Link> */}
                </div>
                {dataCloudHealthLoader ? (
                  <div className="all-costing-box">
                    {Array.from({ length: 4 }).map((_, index) => (
                      <div key={index} className="single-costing-box common-white-bg">
                        <h5>
                          <Skeleton width={48} height={28} />
                        </h5>
                        <p>
                          <Skeleton width={120} height={16} />
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="all-costing-box">
                    <div className="single-costing-box common-white-bg">
                      <h5>
                        {dataCloudHealthCount?.[0]?.workflowcount
                          ? dataCloudHealthCount?.[0]?.workflowcount
                          : 0}
                      </h5>
                      <p>Recent Workflows</p>
                    </div>
                    <div className="single-costing-box common-white-bg">
                      <h5>
                        {dataCloudHealthCount?.[0]?.machinecount
                          ? dataCloudHealthCount?.[0]?.machinecount
                          : 0}
                      </h5>

                      <p>Recent Machines</p>
                    </div>
                    <div className="single-costing-box common-white-bg">
                      <h5>
                        {dataCloudHealthCount?.[0]?.maintenance
                          ? dataCloudHealthCount?.[0]?.maintenance
                          : 0}
                      </h5>
                      <p>Maintenance Schedule</p>
                    </div>
                    <div className="single-costing-box common-white-bg">
                      <h5>
                        {dataCloudHealthCount?.[0]?.othernotification
                          ? dataCloudHealthCount?.[0]?.othernotification
                          : 0}
                      </h5>
                      <p>Other Notifications</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Container>
      </div>

      <Container>
        <Row className="mt13 mx-0 mb-3">
          {UserData?.associationtype === "Contacts" ? (
            <></>
          ) : (
            <>
              <Col md={8} className="xxl-pr20 pe13 ps-0"></Col>
              <Col md={4} className="p-0"></Col>
            </>
          )}

          <Col xl={9} className="p-0"></Col>
        </Row>
      </Container>

      {modalShow && (
        <DeleteModal
          payload={DeletePayload}
          url={API_URL.WORKFLOW.UPDATE_WORKFLOW_STATUS}
          show={modalShow}
          bindlist={getWorkFlowList}
          onHide={(e) => setModalShow(false)}
        />
      )}
      {showNotification ? (
        <>
          <Overlay
            target={target2.current}
            show={showNotification}
            placement="bottom"
          >
            {(props) => (
              <Tooltip id="overlay-example" {...props}>
                <NotificationPopup
                  closePopup={handleshowNotification}
                  associationId={notificationPayloadRef.current?.associationId}
                  associationType={
                    notificationPayloadRef.current?.associationType
                  }
                />
              </Tooltip>
            )}
          </Overlay>
        </>
      ) : (
        ""
      )}
      {showSchedulerPopup && (
        <Overlay
          target={targetSchedularRef.current}
          show={showSchedulerPopup}
          placement="bottom"
        >
          {(props) => (
            <Tooltip id="overlay-example" {...props}>
              <SchedularPopup
                isViewMode={
                  location?.pathname?.includes("/dashboard") ||
                  location?.pathname?.includes("/workflows")
                }
                handleSubmit={handleSchedularSubmit}
                handleshowPopup={handleshowSchedulerPopup}
                CronParseValues={CronParseValues}
                flowName={flowName}
                schedularData={schedularData}
              />
            </Tooltip>
          )}
        </Overlay>
      )}

      {modalShow1 && (
        <WorkFlowLogModal
          show={modalShow1}
          id={logId}
          onHide={() => setModalShow1(false)}
        />
      )}
      {PaymentPopup && PaymentPopup.show && PaymentPopup.invoiceitem && (
        <PaymentMethodSelection
          show={PaymentPopup.show}
          item={PaymentPopup.invoiceitem}
          itemtype={PaymentPopup.itemtype || "Workflow Invoice"}
          returnpath="/dashboard"
          onPaymentSuccess={() => {
            fngetCostwidgetdata();
          }}
          onHide={() => {
            setPaymentPopup({
              show: false,
              invoiceitem: null,
              itemtype: "Workflow Invoice",
            });
            fngetCostwidgetdata();
          }}
        />
      )}
      {OnlinePaymentDetails && (
        <Modal
          show={OnlinePaymentDetails.isshow}
          onHide={() =>
            setOnlinePaymentDetails({
              ...OnlinePaymentDetails,
              isshow: false,
            })
          }
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="delete-modal"
          backdrop="static"
        >
          <Modal.Body>
            <div className="text-center">
              {OnlinePaymentDetails.message === "SUCCEEDED" && (
                <>
                  <img src={payment_success} alt="SUCCEEDED" />
                  <h4 className="text-success">
                    {OnlinePaymentDetails.message}
                  </h4>
                  {OnlinePaymentDetails.from.toLowerCase() === "bill_add_card" ? (
                    <p className="text-success">
                      Successfully added new method of payment.
                    </p>
                  ) : (
                    <p className="text-success">
                      Your payment was successful. Thank you!
                    </p>
                  )}
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-success"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOnlinePaymentDetails({
                          ...OnlinePaymentDetails,
                          isshow: false,
                        });
                        refreshpagedata(OnlinePaymentDetails.from);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </>
              )}
              {OnlinePaymentDetails.message === "CANCELED" && (
                <>
                  <img src={payment_cancel} alt="CANCELED" />
                  <h4 className="text-danger">
                    {OnlinePaymentDetails.message}
                  </h4>
                  <p className="text-danger">
                    Your payment was canceled. No charges were made.
                  </p>
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOnlinePaymentDetails({
                          ...OnlinePaymentDetails,
                          isshow: false,
                        });
                        refreshpagedata(OnlinePaymentDetails.from);
                      }}
                    >
                      Try Again
                    </button>
                  </div>
                </>
              )}
              {(OnlinePaymentDetails.message === "PROCESSING" ||
                OnlinePaymentDetails.message === "") && (
                <>
                  <img src={payment_inprocess} alt="PROCESSING" />
                  <h4 className="text-warning">
                    {OnlinePaymentDetails.message}
                  </h4>
                  <p className="text-warning">
                    Your payment is currently being processed. It may take up to
                    48 hours for the payment to be cleared.
                  </p>
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-warning"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOnlinePaymentDetails({
                          ...OnlinePaymentDetails,
                          isshow: false,
                        });
                        refreshpagedata(OnlinePaymentDetails.from);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </>
              )}
              {OnlinePaymentDetails.message === "APICALLING" && (
                <>
                  <img src={payment_wait} alt="WAIT" />
                  <h4>Wait for completion</h4>
                  <p>
                    Do not refresh your browser until you see the next message.
                  </p>
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}

      {showMachineWiseCostPopup && (
        <Overlay
          target={
            targetMachinewiseRef.current[`${machinewiseworkflowid}_${showtype}`]
              ?.current
          }
          show={showMachineWiseCostPopup}
          placement="bottom"
        >
          {(props) => (
            <Tooltip id="overlay-example" {...props}>
              <MachineWiseCostPopup
                projectname={machinewiseflowName}
                workflowid={machinewiseworkflowid}
                showtype={showtype}
                handleshowPopup={handleshowMachineWiseCostPopup}
              />
            </Tooltip>
          )}
        </Overlay>
      )}

      {/* Legend Modal */}
      {showLegendModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={() => {
            setShowLegendModal(false);
            setLegendSearchTerm('');
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              padding: '24px',
              width: '500px',
              height: '600px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexShrink: 0 }}>
              <h4 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>{ChartReportHandle.databy === 'workflow' ? 'Workflow Legend' : 'Machine Legend'}</h4>
              <button
                onClick={() => {
                  setShowLegendModal(false);
                  setLegendSearchTerm('');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#999',
                }}
              >
                ✕
              </button>
            </div>

            {/* Search Input */}
            <input
              type="text"
              placeholder="Search items..."
              value={legendSearchTerm}
              onChange={(e) => setLegendSearchTerm(e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                marginBottom: '12px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px',
                boxSizing: 'border-box',
                flexShrink: 0,
              }}
            />

            {/* Select All / Unselect All Buttons */}
            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexShrink: 0 }}>
              <button
                onClick={() => {
                  if (window.chartInstance && window.chartInstance.chartInstance) {
                    const chart = window.chartInstance.chartInstance;
                    try {
                      legendDatasets.forEach((dataset) => {
                        const meta = chart.getDatasetMeta(dataset.index);
                        meta.hidden = false;
                      });
                      chart.update();
                      setLegendDatasets(
                        legendDatasets.map((d) => ({ ...d, visible: true }))
                      );
                    } catch (err) {
                      console.error('Error selecting all:', err);
                    }
                  }
                }}
                style={{
                  flex: 1,
                  padding: '6px 12px',
                  border: '1px solid #007bff',
                  borderRadius: '4px',
                  backgroundColor: '#007bff',
                  color: '#fff',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '500',
                }}
              >
                Select All
              </button>
              <button
                onClick={() => {
                  if (window.chartInstance && window.chartInstance.chartInstance) {
                    const chart = window.chartInstance.chartInstance;
                    try {
                      legendDatasets.forEach((dataset) => {
                        const meta = chart.getDatasetMeta(dataset.index);
                        meta.hidden = true;
                      });
                      chart.update();
                      setLegendDatasets(
                        legendDatasets.map((d) => ({ ...d, visible: false }))
                      );
                    } catch (err) {
                      console.error('Error unselecting all:', err);
                    }
                  }
                }}
                style={{
                  flex: 1,
                  padding: '6px 12px',
                  border: '1px solid #dc3545',
                  borderRadius: '4px',
                  backgroundColor: '#dc3545',
                  color: '#fff',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '500',
                }}
              >
                Unselect All
              </button>
            </div>

            <div style={{ borderTop: '1px solid #eee', paddingTop: '12px', flex: 1, overflowY: 'auto', minHeight: 0 }}>
              {legendDatasets
                .filter((dataset) =>
                  dataset.label.toLowerCase().includes(legendSearchTerm.toLowerCase())
                )
                .map((dataset, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '12px 12px',
                      borderRadius: '4px',
                      marginBottom: '8px',
                      backgroundColor: dataset.visible ? '#d4edda' : '#e2e3e5',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s',
                      border: '1px solid ' + (dataset.visible ? '#28a745' : '#d0d0d0'),
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = dataset.visible ? '#c3e6cb' : '#d3d4d7';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = dataset.visible ? '#d4edda' : '#e2e3e5';
                    }}
                    onClick={() => {
                      // Toggle dataset visibility when clicking anywhere on the row
                      if (window.chartInstance && window.chartInstance.chartInstance) {
                        const chart = window.chartInstance.chartInstance;
                        try {
                          const meta = chart.getDatasetMeta(dataset.index);
                          const currentHidden = meta.hidden;
                          meta.hidden = !currentHidden;
                          chart.update();

                          // Update legendDatasets state - toggle this specific dataset
                          setLegendDatasets((prevDatasets) =>
                            prevDatasets.map((d) =>
                              d.index === dataset.index
                                ? { ...d, visible: currentHidden }
                                : d
                            )
                          );
                        } catch (err) {
                          console.error('Error toggling visibility:', err);
                        }
                      }
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        width: '12px',
                        height: '12px',
                        backgroundColor: dataset.color,
                        borderRadius: '2px',
                        marginRight: '10px',
                      }}
                    />
                    <span style={{ flex: 1, fontSize: '14px' }}>{dataset.label}</span>
                  </div>
                ))}
              {legendDatasets.filter((dataset) =>
                dataset.label.toLowerCase().includes(legendSearchTerm.toLowerCase())
              ).length === 0 && (
                  <div style={{ textAlign: 'center', padding: '16px', color: '#999' }}>
                    No legend items found
                  </div>
                )}
            </div>

            <div style={{ marginTop: 'auto', display: 'flex', gap: '8px', justifyContent: 'flex-end', borderTop: '1px solid #eee', paddingTop: '12px', flexShrink: 0 }}>
              <button
                onClick={() => {
                  setShowLegendModal(false);
                  setLegendSearchTerm('');
                }}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  backgroundColor: '#fff',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
